module.exports = __webpack_public_path__ + "img/dgroup_7.85489e67.jpg";